<template>
  <section class="dp-layout enrollment-page">
    <aside class="dp-left filter-card">
      <div class="filter-head">
        <i class="el-icon-folder-opened"></i>
        <span>毕业届别目录</span>
      </div>
      <nav class="filter-nav" aria-label="毕业届别目录">
        <button
          type="button"
          class="filter-item"
          :class="{ 'is-active': !selectedYear }"
          @click="onYearSelect('')"
        >
          <span class="filter-item__dot tone-all"></span>
          <span class="filter-item__label">全部届别</span>
          <i class="el-icon-arrow-right filter-item__arrow"></i>
        </button>
        <button
          v-for="y in yearList"
          :key="y"
          type="button"
          class="filter-item is-child"
          :class="{ 'is-active': selectedYear === y }"
          @click="onYearSelect(String(y))"
        >
          <span class="filter-item__dot tone-year"></span>
          <span class="filter-item__label">{{ y }}届</span>
          <i class="el-icon-arrow-right filter-item__arrow"></i>
        </button>
      </nav>
      <div v-if="!yearList.length" class="filter-empty">暂无毕业届别</div>
    </aside>

    <section class="dp-right">
      <header class="page-toolbar">
        <div class="page-toolbar__title">
          <h2>{{ viewTitle }}</h2>
          <p>跟顶部学校切换；升学导入用于跨学段入学，不自动恢复旧卡。</p>
        </div>
        <div class="enrollment-toolbar">
          <div class="toolbar-filter-bar toolbar-filter-bar--embed enrollment-toolbar__query">
            <el-form :inline="true" class="toolbar-filter-form">
              <div class="toolbar-filter-fields">
                <el-form-item>
                  <el-input
                    v-model="sourceClassName"
                    placeholder="原班级"
                    clearable
                    prefix-icon="el-icon-office-building"
                    class="toolbar-field-w-md"
                    @keyup.enter.native="loadList(1)"
                  />
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="keyword"
                    placeholder="姓名 / 学号 / 证件号"
                    clearable
                    prefix-icon="el-icon-search"
                    class="toolbar-field-w-lg"
                    @keyup.enter.native="loadList(1)"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" icon="el-icon-search" @click="loadList(1)">查询</el-button>
                </el-form-item>
              </div>
              <div class="toolbar-filter-actions">
                <el-button size="small" type="info" icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
                <el-button size="small" type="warning" icon="el-icon-upload2" @click="openPromotion">升学导入</el-button>
              </div>
            </el-form>
          </div>
          <div v-if="isDingTalkSchool" class="enrollment-toolbar__extra">
            <span class="enrollment-toolbar__extra-label">天波</span>
            <enrollment-tb-residual-toolbar
              :scope-kind="1"
              :school-department-id="activeSchoolId"
              :filter-params="tbFilterParams"
              :only-tb-remaining.sync="onlyTbRemaining"
              @filter-change="loadList(1)"
              @deleted="onTbDeleted" />
          </div>
        </div>
      </header>

            <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
            <div class="tbl-scroll-host">
            <el-table height="100%"
        :data="list"
        v-loading="loading"
        border
        stripe
        class="custom-tbl enrollment-table"
        style="width: 100%"
        empty-text="暂无毕业学生"
      >
        <el-table-column type="index" label="#" width="50" />
        <el-table-column prop="StuName" label="姓名" min-width="100" />
        <el-table-column prop="StuCode" label="学号" min-width="110" show-overflow-tooltip />
        <el-table-column prop="CardNumber" label="卡号" min-width="120" show-overflow-tooltip />
        <el-table-column prop="SourceDepartmentName" label="原毕业班级" min-width="140" show-overflow-tooltip />
        <el-table-column prop="GraduationYear" label="届别" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="info" effect="plain">{{ scope.row.GraduationYear }}届</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="StatusChangedAt" label="毕业操作时间" min-width="160" />
        <el-table-column v-if="isDingTalkSchool" label="天波" width="88" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.TbThirdPartId > 0" size="mini" type="warning" effect="plain">已同步</el-tag>
            <span v-else class="tb-empty">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="ContactPhone" label="监护人信息" min-width="120" show-overflow-tooltip />
        <el-table-column label="操作" width="110" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" class="op-link" @click="openRollback(scope.row)">毕业回退</el-button>
          </template>
        </el-table-column>
      </el-table>
            </div>

      <div class="pager-bar">
        <el-pagination
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :total="total"
          :current-page.sync="page"
          @current-change="loadList"
        />
      </div>
    </section>

    <el-dialog title="毕业回退" :visible.sync="rollbackVisible" width="560px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="学生">{{ rollbackRow && rollbackRow.StuName }}</el-form-item>
        <el-form-item label="目标班级" required>
          <class-cascader-select
            v-model="rollbackTargetDeptId"
            :school-id="activeSchoolId"
            placeholder="校区 / 学段 / 年级 / 班级"
          />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="rollbackReason" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rollbackVisible = false">取消</el-button>
        <el-button type="primary" :loading="rollbackSaving" @click="submitRollback">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="升学导入" :visible.sync="promotionVisible" width="820px" :close-on-click-modal="false">
      <el-alert
        :title="selectedYear
          ? '按本届全部来源毕业班映射到目标班（非整页数据）。用于小升初、初升高等跨学段。'
          : '当前为全部届别：汇总所有待导入来源班映射到目标班。用于小升初、初升高等跨学段。'"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 12px;"
      />
      <el-table :data="promotionMappings" v-loading="promotionLoading" border size="small"
        :empty-text="selectedYear ? '该届暂无待导入的来源班' : '暂无待导入的来源班'">
        <el-table-column prop="sourceName" label="来源毕业班" min-width="150" />
        <el-table-column prop="StudentCount" label="人数" width="80" align="right" />
        <el-table-column label="目标班级" min-width="320">
          <template slot-scope="scope">
            <class-cascader-select
              v-model="scope.row.TargetDepartmentId"
              :school-id="activeSchoolId"
              size="mini"
              placeholder="校区 / 学段 / 年级 / 班级"
            />
          </template>
        </el-table-column>
      </el-table>
      <div v-if="promotionTotalStudents > 0" class="promotion-summary">
        共 {{ promotionMappings.length }} 个来源班，{{ promotionTotalStudents }} 名学生待导入
      </div>
      <el-form label-width="80px" style="margin-top: 12px;">
        <el-form-item label="说明">
          <el-input v-model="promotionReason" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="promotionVisible = false">取消</el-button>
        <el-button type="primary" :loading="promotionSaving" :disabled="promotionLoading || !promotionMappings.length"
          @click="submitPromotion">执行导入</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  getGraduateYearTree,
  getGraduateArchivePage,
  rollbackGraduate,
  getPromotionClassOptions,
  promotionImport
} from '../../api/modules/studentEnrollment';
import ClassCascaderSelect from '../../components/ClassCascaderSelect';
import EnrollmentTbResidualToolbar from '../../components/EnrollmentTbResidualToolbar';
import dingTalkSchoolMixin from '../../mixins/dingTalkSchoolMixin';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';

export default {
  name: 'GraduateStudentArchive',
  mixins: [dingTalkSchoolMixin],
  components: { ClassCascaderSelect, EnrollmentTbResidualToolbar },
  data() {
    return {
      yearList: [],
      selectedYear: null,
      sourceClassName: '',
      keyword: '',
      list: [],
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      rollbackVisible: false,
      rollbackRow: null,
      rollbackTargetDeptId: null,
      rollbackReason: '毕业回退',
      rollbackSaving: false,
      promotionVisible: false,
      promotionLoading: false,
      promotionMappings: [],
      promotionReason: '升学导入',
      promotionSaving: false,
      onlyTbRemaining: false
    };
  },
  computed: {
    tbFilterParams() {
      const params = {
        SourceClassName: this.sourceClassName,
        Keyword: this.keyword
      };
      if (this.selectedYear) params.GraduationYear = this.selectedYear;
      return params;
    },
    viewTitle() {
      return this.selectedYear ? `${this.selectedYear}届毕业档案` : '全部毕业档案';
    },
    activeSchoolId() {
      return resolveActiveSchoolId(this);
    },
    promotionTotalStudents() {
      return (this.promotionMappings || []).reduce((sum, row) => sum + (Number(row.StudentCount) || 0), 0);
    }
  },
  watch: {
    activeSchoolId: {
      immediate: true,
      async handler() {
        await this.loadCurrentSchoolSchType(this.activeSchoolId);
        if (!this.isDingTalkSchool) this.onlyTbRemaining = false;
        this.bindSchoolAndLoad();
      }
    }
  },
  methods: {
    async bindSchoolAndLoad() {
      if (!this.activeSchoolId) {
        this.yearList = [];
        this.list = [];
        this.total = 0;
        this.$message.warning('请先在顶部选择学校');
        return;
      }
      this.selectedYear = null;
      await this.loadYears();
      this.loadList(1);
    },
    loadYears() {
      return getGraduateYearTree({ schoolDepartmentId: this.activeSchoolId }).then(res => {
        if (res.data && res.data.success) {
          const tree = res.data.response || [];
          this.yearList = tree.map(x => x.GraduationYear || x.Id).filter(Boolean);
        } else {
          this.yearList = [];
          if (res.data && res.data.msg) {
            this.$message.error(res.data.msg);
          }
        }
      });
    },
    onYearSelect(index) {
      this.selectedYear = index === '' ? null : Number(index);
      this.loadList(1);
    },
    resetQuery() {
      this.sourceClassName = '';
      this.keyword = '';
      this.onlyTbRemaining = false;
      this.loadList(1);
    },
    loadList(page) {
      if (!this.activeSchoolId) {
        this.$message.warning('请先在顶部选择学校');
        return;
      }
      if (page) this.page = page;
      this.loading = true;
      const params = {
        schoolDepartmentId: this.activeSchoolId,
        sourceClassName: this.sourceClassName,
        keyword: this.keyword,
        page: this.page,
        intPageSize: this.pageSize
      };
      if (this.selectedYear) params.graduationYear = this.selectedYear;
      if (this.onlyTbRemaining) params.onlyTbRemaining = true;
      getGraduateArchivePage(params)
        .then(res => {
          this.loading = false;
          if (res.data && res.data.success) {
            const pageModel = res.data.response || {};
            this.list = pageModel.data || [];
            this.total = pageModel.dataCount || 0;
          } else {
            this.$message.error((res.data && res.data.msg) || '加载失败');
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onTbDeleted() {
      this.loadList(1);
    },
    openRollback(row) {
      this.rollbackRow = row;
      this.rollbackTargetDeptId = null;
      this.rollbackReason = '毕业回退';
      this.rollbackVisible = true;
    },
    submitRollback() {
      if (!this.rollbackRow || !this.rollbackTargetDeptId) {
        this.$message.warning('请选择目标班级');
        return;
      }
      this.rollbackSaving = true;
      rollbackGraduate({
        Reason: this.rollbackReason,
        Items: [{
          StudentId: this.rollbackRow.Id,
          TargetDepartmentId: Number(this.rollbackTargetDeptId)
        }]
      }).then(res => {
        this.rollbackSaving = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '回退成功');
          this.rollbackVisible = false;
          this.loadYears();
          this.loadList();
        } else {
          this.$message.error((res.data && res.data.msg) || '回退失败');
        }
      }).catch(() => {
        this.rollbackSaving = false;
      });
    },
    openPromotion() {
      if (!this.activeSchoolId) {
        this.$message.warning('请先在顶部选择学校');
        return;
      }
      this.promotionMappings = [];
      this.promotionReason = '升学导入';
      this.promotionVisible = true;
      this.promotionLoading = true;
      const params = { schoolDepartmentId: this.activeSchoolId };
      if (this.selectedYear) params.graduationYear = this.selectedYear;
      getPromotionClassOptions(params).then(res => {
        this.promotionLoading = false;
        if (!(res.data && res.data.success)) {
          this.$message.error((res.data && res.data.msg) || '加载来源班失败');
          return;
        }
        const rows = res.data.response || [];
        this.promotionMappings = rows.map(item => ({
          SourceDepartmentId: item.SourceDepartmentId,
          sourceName: item.SourceDepartmentName || String(item.SourceDepartmentId),
          StudentCount: item.StudentCount || 0,
          TargetDepartmentId: null
        }));
        if (!this.promotionMappings.length) {
          this.$message.warning(this.selectedYear ? '该届暂无待导入的毕业班级' : '暂无待导入的毕业班级');
        }
      }).catch(() => {
        this.promotionLoading = false;
        this.$message.error('加载来源班失败');
      });
    },
    submitPromotion() {
      const invalid = this.promotionMappings.find(x => !x.TargetDepartmentId);
      if (invalid) {
        this.$message.warning('请为每个来源班选择目标班级');
        return;
      }
      this.promotionSaving = true;
      promotionImport({
        SchoolDepartmentId: this.activeSchoolId,
        GraduationYear: this.selectedYear || 0,
        Reason: this.promotionReason,
        Mappings: this.promotionMappings.map(x => ({
          SourceDepartmentId: x.SourceDepartmentId,
          TargetDepartmentId: Number(x.TargetDepartmentId)
        }))
      }).then(res => {
        this.promotionSaving = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '导入成功');
          this.promotionVisible = false;
          this.loadYears();
          this.loadList();
        } else {
          this.$message.error((res.data && res.data.msg) || '导入失败');
        }
      }).catch(() => {
        this.promotionSaving = false;
      });
    }
  }
};
</script>

<style scoped>
.enrollment-page {
  --enroll-primary: #3b82f6;
  --enroll-ink: #1e293b;
  --enroll-muted: #64748b;
  --enroll-line: #e2e8f0;
}

.filter-card {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}

.filter-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 18px 12px;
  font-size: 15px;
  font-weight: 600;
  color: var(--enroll-ink);
  border-bottom: 1px solid var(--enroll-line);
}

.filter-head i {
  color: var(--enroll-primary);
}

.filter-nav {
  padding: 10px 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}

.filter-empty {
  /* 与子届别项缩进对齐。最后修改：2026-08-30 */
  padding: 8px 18px 16px 38px;
  font-size: 12px;
  color: var(--enroll-muted);
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  background: transparent;
  border-radius: 8px;
  padding: 11px 12px;
  cursor: pointer;
  color: var(--enroll-ink);
  transition: background-color 0.18s ease, color 0.18s ease;
  text-align: left;
}

.filter-item:hover {
  background: #f1f5f9;
}

.filter-item.is-active {
  background: #eff6ff;
  color: var(--enroll-primary);
  font-weight: 600;
}

/* 具体届别相对「全部届别」缩进一层。创建于 2026-08-30 */
.filter-item.is-child {
  padding-left: 28px;
}

.filter-item__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #94a3b8;
}

.filter-item__dot.tone-all { background: #3b82f6; }
.filter-item__dot.tone-year { background: #0ea5e9; }

.filter-item__label {
  flex: 1;
  font-size: 13px;
  line-height: 1.4;
}

.filter-item__arrow {
  font-size: 12px;
  color: #cbd5e1;
  opacity: 0;
  transition: opacity 0.18s ease;
}

.filter-item.is-active .filter-item__arrow,
.filter-item:hover .filter-item__arrow {
  opacity: 1;
}

.page-toolbar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 0 0 auto;
  margin-bottom: 12px;
}

.enrollment-toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 0 0 auto;
}

.enrollment-toolbar__query {
  margin-bottom: 0;
  flex: 0 0 auto;
  width: 100%;
}

.enrollment-toolbar__extra {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.enrollment-toolbar__extra-label {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  flex-shrink: 0;
}

.page-toolbar__title h2 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
  color: var(--enroll-ink);
}

.page-toolbar__title p {
  margin: 0;
  font-size: 12px;
  color: var(--enroll-muted);
}

.op-link {
}

.promotion-summary {
  margin-top: 10px;
  color: #64748b;
  font-size: 12px;
}

.tb-empty {
  color: #cbd5e1;
}

.pager-bar {
  display: flex;
  justify-content: flex-end;
  flex: 0 0 auto;
  margin-top: 12px;
}

@media (max-width: 960px) {
  .enrollment-page {
    flex-direction: column;
  }
  .filter-card {
    width: 100% !important;
    margin-right: 0 !important;
    margin-bottom: 16px;
  }
  /* 与全站一致：类型/届别筛选保持单列。最后修改：2026-08-24 */
  .filter-nav {
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .filter-item {
    width: 100%;
    flex: 0 0 auto;
  }
}
</style>
